export default {
  Close: 'Close',
  Confirm: 'Confirm',
  header: {
    Home: 'Home',
    MyOrder: 'My order',
    Login: 'Login',
    changeYourPassword: 'Change your password',
    logout: 'Logout'
  },
  Announcement: 'Announcement',
  WeChatTitle: 'WeChat official account of the Emperor QinShihuang’s Mausoleum Site Museum',
  PleaseUseWeChat: 'Please use WeChat to scan the QR code of the official account above',
  CountDown: 'Count Down',
  CountDownComplete: 'close',
  buyTicket: {
    selectAVisitDate: 'Select a visit date',
    selectAVisitTime: 'Please select your preferable time period for check-in',
    selectTicketType: 'Select ticket type',
    maxNum: `A maximum of &valItem tickets can be purchased in one order`,
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    notBooking: 'Not available for booking',
    ticketBalance: 'Ticket balance',
    productName: 'Product name',
    ticketType: 'Ticket type',
    ticketingInstructions: 'Ticketing instructions',
    PleaseRead: 'Please read the instructions carefully',
    IRead: 'I have read the instructions in detail, continue to book',
    UnitPrice: 'Unit price',
    Quantity: 'Quantity',
    noDataAvailable: 'No data available',
    telephoneConsultation: 'Telephone consultation',
    onlineConsultation: 'Online consultation',
    weChatOfficialAccount: 'WeChat official account',
    Reminder: 'Reminder',
    totalPrice: 'Total price',
    placeOrder: 'Place order',
    ticketingInstructions: 'Ticketing instructions',
    Total: 'Total',
    totalNum: '&valItem ticket in total',
    TotalPrice: 'Total price',
    LatestAnnouncement: 'Latest announcement',
    viewMore: 'View more'
  },
  // 购票进程
  TicketingProcessObj: {
    TicketingProcess: 'Ticketing process',
    TimeOut: 'select your preferable time period for check-in',
    selectTicketType: 'Select ticket type',
    FillOrder: 'Fill out order information',
    OrderPayment: 'Order payment',
    Completed: 'Completed'
  },
  // 账号密码登录
  LoginObj: {
    LoginAndPassword: 'Login by account name and password',
    LoginCode: 'Login by verification code ',
    PleaseNumber: 'Please enter your mobile phone number',
    PleasePassword: 'Please enter your password',
    Change: 'Change',
    PleaseCode: 'Please enter the verification code',
    PleaseAgain: 'Please enter the password again',
    LogIn: 'Log in',
    SignUpNow: 'Sign up now',
    ForgotPassword: 'Forgot password',
    AgreeDisclaimer: 'Agree to the membership terms and disclaimer',
    GetVerificationCode: 'Get verification code',
    Reacquire: 'Reacquire',
    NoAccount: 'No account',
    ChangePassword: 'Change your password',
    Logout: 'Logout',
    ExistingAccount: '已有账号',
    ImmediatelyFind: '立即找回'
  },
  // 下单页
  FillOrder: {
    FillOrder: 'Fill out order information',
    FillOrderTitle: 'Emperor QinShihuang’s Mausoleum Site Museum adopts a real-name system for tickets purchasing, and all visitors are required to input their identity information before make a reservation',
    VisitDate: 'Visit date',
    Name: 'Name',
    DocumentType: 'Document type',
    IDCard: 'ID card',
    Passport: 'Passport',
    Others: 'Others',
    IDNumber: 'ID number',
    SpecialIDType: 'Special ID type',
    SpecialIDNumber: 'Special ID number',
    DeleteThisContact: 'Delete this contact',
    PleaseYourName: 'Please type in your name',
    PleaseIDNumber: 'Please enter the ID number',
    PleaseSpecialIDNumber: 'Please enter the Special ID Number',
    PleaseenterContact: 'Please enter the contact\'s mobile phone number',
    Delete: 'Delete',
    information: 'Contact information',
    informationSub: ' (please fill in accurately in case you can\'t receive the order information)',
    ContactPhoneNumber: 'Contact phone number',
    TotalAmount: 'Total amount',
    BuyNow: 'Buy now',
    ConfirmReminder: 'Confirm reminder',
    DoubleConfirm: 'Double confirm',
    Confirmed: 'Confirmed',
    BeforeBy: 'Before buying, please confirm whether the identity information is input correctly, so as not to affect your visiting experience.',
    OutByOrder: 'Tips',
    Mausoleum: 'Welcome to the Emperor Qinshihuang’s Mausoleum Site Museum! Tips: Daily system maintenance, maintenance time is from 23:30 to 02:30 the next day, ticketing services will be suspended during this period.',
    Reminder: 'Reminder',
    PleaseCorrectInformation: 'Please fill in the correct information',
    AgeDiscountRange: 'Your age is not within the discount range',
    InvalidIDNumber: 'Invalid ID number',
    productName: 'Product name',
    ticketType: 'Ticket type',
    Quantity: 'Quantity',
    UnitPrice: 'Unit price'
  },
  back: 'Back',
  // 支付
  payOrder: {
    OrderQuantity: 'Order quantity ',
    NumberProducts: 'Number of products',
    OrderInformation: 'Order information',
    VisitTime: 'Visit time',
    TicketName: 'Ticket name',
    ticketType: 'Ticket type',
    UnitPrice: 'Unit price',
    Quantity: 'Quantity',
    PaymentOrderSeconds: 'Payment order remaining time &item1 minutes &item2 seconds',
    PleaseComplete: 'Please complete in time, otherwise the order will be automatically cancelled',
    Alipay: 'Alipay',
    WeChat: 'WeChat',
    PleaseQRcodepay: 'Please scan the QR code to pay',
    Orderpaymenttimeout: 'Order payment timeout, please place a new order！',
    goFillOrderL: 'Go to place an order',
    Backtohome: 'Back to home',
    Checkorder: 'Check order',
    Refund: 'Refund',
    TicketReplacement: 'Ticket replacement',
    ChangeTicket: 'Change your ticket',
    RefundProgress: 'Refund in progress'
  },
  Cancel: 'Cancel',
  Backtohome: 'Back to home',
  Checkorder: 'Check order',
  LatestAnnouncement: 'Latest announcement',
  PreviousPage: 'Previous page',
  NextPage: 'Next page',
  ReleaseTime: 'Release time',
  MyOrder: {
    MyOrder: 'My order',
    OrderCenter: 'Order center',
    All: 'All',
    Completed: 'Completed',
    ToBePaid: 'To be paid',
    OrderNumber: 'Order number',
    VisitorIDNumber: 'Visitor\'s ID Number',
    Inquire: 'Inquire',
    Reset: 'Reset',
    OrderPlacementTime: 'Order placement time',
    Contactphonenumber: 'Contact phone number',
    OrderStatus: 'Order Status',
    Startdate: 'Start date',
    EndDate: 'end date',
    VisitTime: 'Visit time',
    Visitdate: 'Visit date',
    VisitTimePeriod: 'Visit time period',
    Actualpaymentpaymentmethod: 'Actual payment / payment method',
    Operating: 'Operating',
    OrderDetails: 'Order details',
    Paymentquery: 'Payment query',
    Expandall: 'Expand all',
    CreationDate: 'Creation Date',
    Fullorderamount: 'Full order amount',
    Fullpayment: 'Full payment ',
    Fullrefund: 'Full refund',
    Handlingfee: 'Handling fee',
    Ticketnumber: 'Ticket number',
    TicketcheckingQRcode: 'Ticket checking QR code',
    Effectivedate: 'Effective date',
    Effectivetime: 'Effective time',
    Numberofpeople: 'Number of people',
    Numberoftimes: 'Number of times',
    Ticketcollectiondate: 'Ticket collection date',
    Numberofprints: 'Number of prints',
    Numberofticketschecked: 'Number of tickets checked',
    Ticketstatus: 'Ticket status',
    Checkingrecords: 'Checking records',
    Uncollectedticket: 'Uncollected ticket',
    Void: 'Void',
    Checkinrecords: 'Check-in records',
    Close: 'Close',
    Checkininformation: 'Check-in information',
    Ticketidentificationnumber: 'Ticket identification number',
    Checkindate: 'Check-in date',
    Checkintime: 'Check-in time',
    Checkpointname: 'Checkpoint name',
    Nodataavailable: 'No data available',
    Price: 'Price',
    Handlingfee: 'Handling fee',
    selectText: '&item1ticket has been selected for a total of',
    selectText2: 'deducting handling fee of',
    selectVisitTime: 'Please select a visiting time'
  },
  orderStatus: {
    Pendingreview: 'Pending review',
    Closed: 'Closed',
    Issued: 'Issued',
    Tobepaid: 'To be paid',
    Refunded: 'Refunded',
    Completed: 'Completed'
  },
  status: 'status',
  Ticketcollectionstatus: 'Ticket collection status',
  Pickedup: 'Picked up',
  NotPickup: 'Not Pick up',
  Ticketcheckintype: 'Ticket check-in type',
  Normalticketcheckin: 'Normal ticket check-in',
  Freeadmissionticketcheckin: 'Free admission ticket check-in',
  Mandatoryticketcheckin: 'Mandatory ticket check-in',
  Ticketcheckmedia: 'Ticket check-in media',
  Ticketidentificationnumber: 'Ticket identification number',
  Checkindate: 'Check-in date',
  Checkintime: 'Check-in time',
  Checkpointname: 'Checkpoint name',
  el: {
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共{total}条',
      pageClassifier: '页'
    }
  }
}
